export const isParamNumeric = (param: string | undefined): boolean => {
  if (param === undefined) {
    return false;
  }
  if (param.trim().length === 0 || isNaN(Number(param))) {
    return false;
  }
  return true;
};
